import { useCallback, useEffect, useState } from 'react';
import useLoading from '../../../../utils/hooks/useLoading';
import useSiteSettings from '../../../../utils/hooks/useSiteSettings';
import useNotifications from './useNotifications';

const useMaxYearsFromPresentLimit = (isTruck = false) => {
  const [value, setValue] = useState();
  const { loading, withLoading } = useLoading();
  const { getValue, saveValue } = useSiteSettings(
    `funding.max_years_from_present_limit${isTruck ? '_truck' : ''}`
  );
  const notifications = useNotifications();

  const update = useCallback((v) => {
    return withLoading(async () => {
      await saveValue(v);
      setValue(v);
      notifications.updateSuccess();
    }, notifications.updateFail);
  }, []);

  useEffect(() => {
    withLoading(async () => {
      const v = await getValue();
      setValue(v);
    }, notifications.getFail);
  }, []);

  return {
    loading,
    value,
    update
  };
};

export default useMaxYearsFromPresentLimit;
